import { Button } from "~/features/ui/button";
import ArrowRight from "~/public/icons/arrow-right.svg";

type Props = {
  onClear: () => void;
};

export function NoResults(props: Props) {
  const { onClear } = props;

  return (
    <div>
      <p tw="text-mobile-title-20-normal mb-16 lg:text-desktop-title-20-normal">No results match</p>
      <p tw="text-mobile-body-30-normal lg:text-desktop-body-30-normal mb-32">
        The active filters are hiding all results.
      </p>
      <Button onClick={onClear} icon={ArrowRight} variant="secondary">
        Clear filters
      </Button>
    </div>
  );
}
